<script>
  import { onMount } from 'svelte';

  import { navigationStore } from '../../stores';

  import Footer from '../../views/Footer.svelte';
  import Headline from './Headline.svelte';
  import Sensor from './Sensor.svelte';
  import Installing from './Installing.svelte';
  import Network from './Network.svelte';

  onMount(async () => {
    const hash = $navigationStore.to.hash;

    if (hash) {
      const elm = document.getElementById(hash.replace('#', ''));

      if (elm) {
        setTimeout(() => elm.scrollIntoViewIfNeeded(true), 500);
      }
    }
  });
</script>

<style lang="scss">

</style>

<main>
  <Headline />
  <Sensor />
  <Installing />
  <Network />
  <Footer />
</main>
